import { createContext, FC, ReactElement } from 'react';
import { JsonObject } from '@/lib/helpers';
import ConfirmModal from '@/components/modals/confirm';
import DeleteModal from '@/components/modals/delete';
import NewWithNameModal from '@/components/modals/new-with-name';
import AppErrorModal from '@/components/modals/app-error';

export type ModalConfig = {
  key: string;
  Component: FC;
  modalType: ModalType;
  props?: JsonObject;
};

export type ModalElement = {
  key: string;
  element: ReactElement;
};

export type Modal = ModalConfig | ModalElement;

export type ModalType = 'confirm' | 'delete' | 'user' | 'new-with-name' | 'app-error';

export const modalTypeMap: Map<ModalType, FC> = new Map();

modalTypeMap.set('confirm', ConfirmModal);
modalTypeMap.set('delete', DeleteModal);
modalTypeMap.set('user', ConfirmModal);
modalTypeMap.set('new-with-name', NewWithNameModal);
modalTypeMap.set('app-error', AppErrorModal);

export interface IModalState {
  getModalLink: (linkId: string) => JsonObject | null;
  linkModal: (linkId: string, params?: JsonObject) => void;
  modalIsOpen: (modalType: ModalType) => boolean;
  openModal: <T>(modalType: ModalType, props?: T) => void;
  closeModal: () => void;
  modalStack: Modal[];
}

export const ModalContext = createContext<IModalState>({
  getModalLink: () => null,
  linkModal: () => null,
  modalIsOpen: () => false,
  openModal: () => null,
  closeModal: () => null,
  modalStack: [],
});

export const isModalConfig = (modal: Modal): modal is ModalConfig =>
  (modal as ModalConfig).modalType !== undefined;
